import { Action } from '@ngrx/store';

export const DO_GET_HEADERS = '[Banner] Do Get Headers';

export class DoGetHeaders implements Action {
    type = DO_GET_HEADERS;
    constructor () {}
}

export const DO_GET_HEADERS_OK = '[Banner] Do Get Headers OK';
export class DoGetHeadersOK implements Action {
    type = DO_GET_HEADERS_OK;
    constructor (public payload: any) {}
}

export const DO_GET_HEADERS_KO = '[Banner] Do Get Headers KO';
export class DoGetHeadersKO implements Action {
    type = DO_GET_HEADERS_KO;
    constructor (public payload: any) {}
}

export type All = DoGetHeaders | DoGetHeadersOK | DoGetHeadersKO;
